var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.playlistId || _vm.videoId)?_c('div',{staticClass:"play-content"},[_c('div',{attrs:{"id":_vm.playerId}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }